import {uniqueId} from 'lodash'
import avatarUserDefault from '@/assets/images/avatar-user-default.png'

const contactProjectsTable = {
  columns: {
    getColumnsData: 'contactsProjectsColumnsData',
    setColumnsData: 'setContactsProjectsColumnsData'
  },
  rows: {
    getRowsData: 'contactsProjectsRowsData',
    setRowsData: 'setContactsProjectsRowsData'
  }
}

const contactProjectsTableApproved = {
  columns: {
    getColumnsData: 'contactsProjectsColumnsDataApproved',
    setColumnsData: 'setContactsProjectsColumnsDataApproved'
  },
  rows: {
    getRowsData: 'contactsProjectsRowsDataApproved',
    setRowsData: 'setContactsProjectsRowsDataApproved'
  }
}

const columns = [
  {
    title: 'PROJECT NAME',
    property: 'name',
    checkmark: true,
    info: 'coast',
    infoTitle: 'Project Amount',
    nameRoute: 'ProjectCard',
    checkRoute: 'serviceProjectManagerInstanceIdIsDelete',
    settingsRoute: {
      nameParam: 'projectId',
      valParam: 'serviceProjectManagerInstanceId'
    }
  },
  {
    title: 'PROFORMA NO.',
    property: 'number',
    editable: 'isProject',
    typeEditable: true,
    hover: 'isProject'
  },
  {
    title: 'BC',
    property: 'businessConsultant.image.path',
    class: 'avatars',
    center: true,
    popup: 'businessConsultant.username',
    type: 'img',
    defaultImg: avatarUserDefault,
    pointer: true,
    hover: true,
    action: 'setManager',
    $type: 'bc'
  },
  {
    title: 'PM',
    property: 'projectManager.image.path',
    class: 'avatars',
    center: true,
    type: 'img',
    popup: 'projectManager.username',
    defaultImg: avatarUserDefault,
    pointer: true,
    hover: true,
    action: 'setManager',
    $type: 'pm'
  },
  {
    title: 'PAID ON',
    property: 'paymentDate',
    type: 'date'
  },
  {
    title: 'STARTED',
    property: 'started',
    editable: true,
    type: 'date',
    typeEditable: 'datePicker',
    class: 'long-date'
  }
]

const toolbar = [
  {
    property: 'action',
    toolbar: {
      hideEditBtn: false,
      hideDeleteBtn: true
    }
  }
]

const completed = [
  {
    title: 'COMPLETED',
    property: 'completedDate',
    type: 'date'
  }
]

const prefix = 'contact_projects_column_'
const callback = (col) => {
  col.id = uniqueId(prefix)
  col.typeTable = 'contactProjects'
  col.actions = {
    edit: true
  }
  return col
}

const contactProjectsTableColumns = columns.concat(toolbar).map(callback)
const contactProjectsTableColumnsApproved = columns.concat(completed).map(callback)

export {
  contactProjectsTable,
  contactProjectsTableApproved,
  contactProjectsTableColumns,
  contactProjectsTableColumnsApproved
}



// WEBPACK FOOTER //
// ./src/constants/TablesOptions/contactsProjectsTable.js